import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { GQLAIUserMessage } from "../utils/types";

const useStyles = makeStyles({
  hideScrollbar: {
    scrollbarWidth: "none" /* Firefox */,
    msOverflowStyle: "none" /* IE 10+ */,
    "&::-webkit-scrollbar": {
      display: "none" /* Safari and Chrome */,
    },
  },
});

export const UserMessage = ({ message }: { message: GQLAIUserMessage }) => {
  const { hideScrollbar } = useStyles();
  const userMsgLines = message.text.split("\n").map((line, i) => <p key={i}>{line}</p>);

  return (
    <div cw-id="user-message" className="cw-flex">
      <div
        className={classNames(
          hideScrollbar,
          "cw-rounded-xl cw-bg-accent-emphasis cw-py-2 cw-px-3 cw-body-base cw-text-13 cw-text-onEmphasis cw-w-fit cw-max-w-2xl cw-overflow-x-scroll",
        )}
      >
        {userMsgLines}
      </div>
    </div>
  );
};
